<template src="./roleslist.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import Endpoints from "@/config/ApiEndpoints.js";

  export default {
    components: {},
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "N/A";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
    },
    data() {
      return {
        Roles: [],
        submitted: false,
        SearchLoader: false,
        Saving: false,
        basic: {
          currentPage: 1,
          totalPages: 0,
        },
        filter: {
          currentPage: 1,
          totalPages: 0,
        },
        filters: {
          name: {
            value: "",
            keys: ["title"],
          },
        },
      };
    },
    mounted() {
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      var AccountRoles = JSON.parse(localStorage.getItem("permissions"));
      if (
        !FleetSubscriptionModules["Hierarchy System"] ||
        AccountRoles.fleet_role_id != 1
      ) {
        this.$router.push("/");
      }

      document.title = pbx_SiteTitle + " - Account Roles";
      this.GetRoles();
    },

    methods: {
      GetRoles() {
        this.SearchLoader = true;
        var obj = { token: localStorage.getItem("token") };
        this.ShowLoader = true;
        Axios.post(Endpoints.Roles.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.SearchLoader = false;
            this.Roles = Response.data.records;
          }
        });
      },
      DeleteUser(id) {
        this.$swal({
          title: "Are you sure You want to delete?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Roles.Delete, {
              token: localStorage.getItem("token"),
              id: id,
            }).then((Response) => {
              if (Response?.data?.success === true) {
                this.$swal.close();
                this.GetRoles();
                this.$swal
                  .fire("Role Deleted Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire(Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
      },
    },
  };
</script>
<style scoped>
  .UsersBody td {
    padding-left: 15px !important;
  }
  .UsersBody .btn-primary {
    border: 1px solid transparent !important;
  }
  .table thead th,
  .table th,
  .table td {
    border: 0 !important;
  }
  @media (min-width: 1280px) and (max-width: 1680px) {
    .actionBTN {
      width: 25%;
    }
  }
  @media (min-width: 780px) and (max-width: 1370px) {
    .actionBTN {
      min-width: 190px;
    }
  }
</style>
